var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHwa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 16,
    viewBox: "0 0 42 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_492_875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6197 0V16H9.1198V9.13938H3.49986V16H0V0H3.49986V5.91535H9.1198V0H12.6197Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9282 0L17.4753 8.38734L17.2376 11.8533H17.4992L19.5236 5.21031H21.6659L23.6902 11.8533H23.9758L23.7381 8.38734L24.2613 0H27.7133L26.2138 16H22.4524L20.7136 10.4241H20.4759L18.7371 16H14.9996L13.4762 0H16.9282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.476 12.534H32.2852L31.4286 16H27.7852L31.8578 0H37.9291L42 16H38.3326L37.476 12.534ZM36.7613 9.62507L35.2619 3.56349H34.4993L32.9999 9.62507H36.7613Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_492_875"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHwa);
export default __webpack_public_path__ + "static/media/HWA.cad5571eaed6ec033dc0eca239a794c4.svg";
export { ForwardRef as ReactComponent };